export default __webpack_public_path__ + "img/intro-mobile-step3.jpg";